import Vue from 'vue'
import Vuex from 'vuex'

import home from './modules/home'
import gifts from './modules/gifts'
import needs from './modules/needs'
import user from './modules/user'
import messages from './modules/messages'
import wishes from './modules/wishes'
import things from './modules/things'
import configs from './modules/configs'
import story from './modules/story'
import thanks from './modules/thanks'
import deals from './modules/deals'
import lovebox from './modules/lovebox'
import commonweals from './modules/commonweals'
import enters from './modules/enters'
import searchs from './modules/searchs'
import festival from './modules/festival'
import moments from './modules/moments'
import express from './modules/express'
import welfare from './modules/welfare'
import carbonlabellings from './modules/carbonlabellings'
import mediatek from './modules/mediatek'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    home,
    gifts,
    needs,
    user,
    messages,
    wishes,
    things,
    configs,
    story,
    thanks,
    deals,
    lovebox,
    commonweals,
    enters,
    searchs,
    festival,
    moments,
    express,
    welfare,
    carbonlabellings,
    mediatek
  },
  strict: debug
})
